import { navigate } from '@reach/router';
import { FormikHelpers } from 'formik';
import { useContext } from 'react';
import { useApiRequest } from '../../../api/useApiRequest';
import { RouteComponentProps } from '../../../helpers/RouteComponentProps';
import { PageContainer } from '../../../layout/Layout';
import { Header1 } from '../../../shared/Headers';
import { CreateOrUpdateDocumentForm } from '../CreateOrUpdateDocumentForm';
import { DocumentFormModel, getInitialDocumentFormModelValues } from '../documentFormModel';
import { HandoverPackSectionContext } from '../documents-section/HandoverPackSectionContext';
import { documentsRoot } from '../documents-section/documentRoutes';
import { CreateDocumentDto, mapDocumentFormModelToCreateCommand } from './createDocumentDto';

type CreateDocumentComponent = (props: RouteComponentProps) => JSX.Element | null;

export const CreateDocument: CreateDocumentComponent = () => {
  const createDocumentEndpoint = 'documents/create';

  const { error, sendRequest } = useApiRequest<undefined, CreateDocumentDto>({
    endpointUrl: createDocumentEndpoint,
    httpMethod: 'post',
  });

  const { refreshContext, handoverPackSections } = useContext(HandoverPackSectionContext);

  const onSubmit = (formModel: DocumentFormModel, formikHelpers: FormikHelpers<DocumentFormModel>) => {
    void sendRequest({
      requestBody: mapDocumentFormModelToCreateCommand(formModel),
      onSuccess: async () => {
        formikHelpers.setSubmitting(false);
        refreshContext();
        await navigate(documentsRoot);
      },
      onFailure: () => {
        formikHelpers.setSubmitting(false);
        formikHelpers.setStatus('Failed');
      },
    });
  };

  return (
    <PageContainer>
      <Header1>Create Document</Header1>
      <CreateOrUpdateDocumentForm
        initialValues={getInitialDocumentFormModelValues(handoverPackSections[0]?.handoverPackSectionId ?? 0)}
        onSubmit={onSubmit}
        error={error}
      />
    </PageContainer>
  );
};
